import { docReady } from "./utils";
import handleNavbarVerticalCollapsed from "./navbar-vertical";
import progressBar from "./progressbar";
import detectorInit from "./detector";
import tooltipInit from "./tooltip";
import popoverInit from "./popover";
import navbarTopDropShadow from "./navbar-top";
import toastInit from "./toast";
import progressAnimationToggle from "./progress";
import glightboxInit from "./glightbox";
import plyrInit from "./plyr";
import initMap from "./googleMap";
import dropzoneInit from "./dropzone";
import choicesInit from "./choices";
import chartLinePaymentInit from "./charts/chart-line-payment";
import settingsPanelInit from "./settings-panel";
import chartRealTimeUserInit from "./charts/chart-real-time-user";
import leafletActiveUserInit from "./leaflet-active-user";
import countupInit from "./countup";
import copyLink from "./copy-link";
import typedTextInit from "./typed";
import navbarDarkenOnScroll from "./navbar-darken-on-scroll";
import scrollToTop from "./scroll-to-top";
import tinymceInit from "./tinymce";
import bulkSelectInit from "./bulk-select";
import quantityInit from "./quantity";
import navbarComboInit from "./navbar-combo";
import listInit from "./list";
import chatInit from "./chat";
import draggableInit from "./draggable";
import kanbanInit from "./kanban";
import { fullCalendarInit } from "./fullcalendar";
import appCalendarInit from "./calendar/index";
import lottieInit from "./lottie";
import wizardInit from "./wizard";
import swiperInit from "./swiper";
import ratingInit from "./rater";
import searchInit from "./search";
import cookieNoticeInit from "./cookie-notice";
import themeControl from "./theme-control";
import topProducts from "./charts/echarts/topProducts";
import totalSales from "./charts/echarts/totalSales";
import weeklySales from "./charts/echarts/weeklySales";
import marketShare from "./charts/echarts/marketShare";
import totalOrder from "./charts/echarts/totalOrder";

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(detectorInit);
docReady(handleNavbarVerticalCollapsed);
docReady(totalOrder);
docReady(weeklySales);
docReady(marketShare);
docReady(totalSales);
docReady(topProducts);
docReady(progressBar);
docReady(navbarTopDropShadow);
docReady(tooltipInit);
docReady(popoverInit);
docReady(toastInit);
docReady(progressAnimationToggle);
docReady(glightboxInit);
docReady(plyrInit);
docReady(initMap);
docReady(dropzoneInit);
docReady(choicesInit);
docReady(settingsPanelInit);
docReady(chartLinePaymentInit);
docReady(chartRealTimeUserInit);
docReady(leafletActiveUserInit);
docReady(countupInit);
docReady(copyLink);
docReady(navbarDarkenOnScroll);
docReady(typedTextInit);
docReady(scrollToTop);
docReady(tinymceInit);
docReady(bulkSelectInit);
docReady(chatInit);
docReady(quantityInit);
docReady(navbarComboInit);
docReady(listInit);
docReady(swiperInit);
docReady(ratingInit);
docReady(draggableInit);
docReady(kanbanInit);
docReady(fullCalendarInit);
docReady(appCalendarInit);
docReady(lottieInit);
docReady(wizardInit);
docReady(searchInit);
docReady(cookieNoticeInit);
docReady(themeControl);
